import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { AuthContext } from '../context/auth';
import { Button, Select } from '../components/common';
import { CreateAvatarFromImage, avatarCardStyle } from '../components/createAvatarFromImage';
import { Replica, Voice } from '../types/types';
import Fredrik from './Fredrik.png'
import Kaisa from './Kaisa.png'
import Krister from './Krister.png'
import { useDropzone } from "react-dropzone";
import { Config } from '../config/config';

// function PptToScenarioPage() {
//   const {authenticated, setAuthenticated} = useContext(AuthContext)
//   const navigate = useNavigate()

//   const [isLoading, setIsLoading] = useState(false)
 
//   return (
//     <Page>
//       <PageHeader>Create Interact From PPT/PDF</PageHeader>
//       <div className="input-group">
//         <input id="file" type="file" onChange={handleFileChange} />
//       </div>
//     </Page>
//   )
// }

function PptToScenarioPage() {
  const {authenticated} = useContext(AuthContext)
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [selectedLanguage, setSelectedLanguage] = useState<string>("");
  const [generateDirectly, setGenerateDirectly] = useState<string>("true");
  const [selectedId, setSelectedId] = useState(null);

  const [replicas, setReplicas] = useState<Replica[]>([]);
  const [creatingAvatar, setCreatingAvatar] = useState(false);
  // The voices a user may use are the voices of the avatars on their
  // account (admins add them, often as voice-only avatars).
  const voices = useMemo<Voice[]>(() => {
    const seen = new Set<string>();
    return replicas.flatMap(replica => {
      if (!replica.has_voice || !replica.tts_voice_id || seen.has(replica.tts_voice_id))
        return [];
      seen.add(replica.tts_voice_id);
      return [{voice_id: replica.tts_voice_id, name: replica.name || replica.tts_voice_id}];
    });
  }, [replicas]);

  const [convertState, setConvertState] = useState<string>("Not Started")

  const imageOptions = [
    { id: 'cvejd985el3s73en2rfg', src: Kaisa, name: "Kaisa" },
    { id: 'cvejdv05el3s73fvasd0', src: Krister, name: "Krister" },
    { id: 'cv882arot3qc73alsst0', src: Fredrik, name: "Fredrik" },
  ];

  const handleImageSelect = (id: any) => {
    setSelectedId(id);
  };

  const trackConvertProgress = async () => {

  }

  useEffect(() => {
    const fetchReplicas = async () => {
      try {
        const response = await fetch(Config.base_url + "/api/v1/accounts/" + authenticated.account + "/replicas", {
          method: "GET",
          headers: {
            'Authorization': 'Bearer ' + authenticated.token
          }
        });
        if (response.ok) {
          const data = await response.json();
          
          setReplicas(data.replicas as Replica[]);
        } else {
          console.error("Failed to fetch replicas:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching replicas:", error);
      }
    };
    fetchReplicas();
  }, [authenticated.account, authenticated.token]);

  const handleSubmit = async () => {
    if (!selectedFile || selectedId === null) {
      alert("Please select a file and an ID.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("replica_id", selectedId);
    formData.append("language", selectedLanguage);
    formData.append("generate_videos", generateDirectly)
    formData.append("flow_id", 'qbrick-standard');

    try {
      const response = await fetch(Config.base_url + "/api/v1/accounts/" + authenticated.account + "/convert-to-interact", {
        method: "POST",
        body: formData,
        headers: {
          'Authorization': 'Bearer ' + authenticated.token
        }
      });

      if (response.ok) {
        setConvertState("Converting")
        trackConvertProgress()
      } else {
        alert("Upload failed");
      }
    } catch (error) {
      console.error("Upload error:", error);
      alert("Error uploading file");
    }
  };

  const onDrop = useCallback((acceptedFiles: any) => {
    if (acceptedFiles.length > 0) {
      setSelectedFile(acceptedFiles[0]);
    }
  }, [])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
      {convertState === "Not Started" ? <>
        <h1>Create from PPT/PDF</h1>
        <p>Select your speaker</p>
        <div style={{display: 'flex', width: '825px', overflowX: 'scroll', padding: '10px', marginBottom: '20px'}}>
          {replicas.map((replica) => (
            <div onClick={() => handleImageSelect(replica.id)} 
              key={replica.id} style={{ border: '1px solid ' + (selectedId === replica.id ? '#008' : '#f2f2f2'), margin: '5px', borderRadius: '10px', backgroundColor: '#f2f2f2', padding: '15px'}}>
              { replica.video_url ? <video 
              
                onMouseOver={()=>{
                  // play video
                  const video = document.getElementById(replica.id) as HTMLVideoElement;
                  if (video) {
                    video.play();
                  }
                }} 
                onMouseOut={()=>{
                  // pause video
                  const video = document.getElementById(replica.id) as HTMLVideoElement;
                  if (video) {
                    video.pause();
                  }
                }} 
                id={replica.id} loop={true} muted={true} autoPlay={false} preload="auto"
                controls={false} width={250} className={`w-24 h-24 cursor-pointer border-4 rounded-lg ${
                  selectedId === replica.id ? "border-blue-500" : "border-gray-300"
                }`}>
                <source src={replica.video_url} type="video/mp4" />
                Your browser does not support the video tag.
              </video> : <img
                src={replica.image_url || imageOptions.find((img) => img.id === replica.id)?.src}
                alt={`Option ${replica.id}`}
                width={250}
                className={`w-24 h-24 cursor-pointer border-4 rounded-lg ${
                  selectedId === replica.id ? "border-blue-500" : "border-gray-300"
                }`}
              /> }
            
            <p>{replica.name}</p>
            </div>
          ))}
          {creatingAvatar ? <CreateAvatarFromImage
            endpoint={Config.base_url + "/api/v1/accounts/" + authenticated.account + "/replicas/photo"}
            voices={voices}
            defaultShared={true}
            onCancel={() => setCreatingAvatar(false)}
            onCreated={(replica) => {
              setReplicas(current => [...current, replica])
              setSelectedId(replica.id as any)
              setCreatingAvatar(false)
            }}
          /> : <div onClick={() => setCreatingAvatar(true)}
            style={{...avatarCardStyle, width: '250px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', border: '1px dashed #999'}}>
            <p>+ Create avatar from image</p>
          </div>}
          {/* {imageOptions.map((image) => (
            <div onClick={() => handleImageSelect(image.id)} 
              key={image.id} style={{ border: '1px solid ' + (selectedId === image.id ? '#008' : '#f2f2f2'), margin: '5px', borderRadius: '10px', backgroundColor: '#f2f2f2', padding: '15px'}}>
            <img
              src={image.src}
              alt={`Option ${image.id}`}
              width={250}
              className={`w-24 h-24 cursor-pointer border-4 rounded-lg ${
                selectedId === image.id ? "border-blue-500" : "border-gray-300"
              }`}
            />
            <p>{image.name}</p>
            </div>
          ))} */}
        </div>
        <div style={{display: 'flex', flexDirection:'row', alignItems: 'space-around'}}>
          <div style={{marginRight: '30px'}}>
            <h3 style={{marginLeft: '10px'}}>Force another language?</h3>
            <Select style={{width: '200px'}} onChange={(evt) => setSelectedLanguage(evt.target.value)}>
              <option value="">According to presentation</option>
              <option value="English">English</option>
              <option value="Swedish">Swedish</option>
              <option value="Finnish">Finnish</option>
              <option value="Norwegian">Norwegian</option>
              <option value="Danish">Danish</option>
              <option value="French">French</option>
              <option value="Spanish">Spanish</option>
              <option value="Italian">Italian</option>
              <option value="Portuguese">Portuguese</option>
              <option value="Russian">Russian</option>
              <option value="Chinese">Chinese</option>
              <option value="Japanese">Japanese</option>
              <option value="Korean">Korean</option>
              <option value="Arabic">Arabic</option>
              <option value="Hindi">Hindi</option>
              <option value="Urdu">Urdu</option>
              <option value="Indonesian">Indonesian</option>
              <option value="Malay">Malay</option>
              <option value="Thai">Thai</option>
              <option value="German">German</option>
            </Select>
          </div>
          <div>
          <h3 style={{marginLeft: '10px'}}>Generate directly?</h3>
            <Select style={{width: '200px'}} onChange={(evt) => setGenerateDirectly(evt.target.value)}>
              <option value="true">Yes, I'm lucky</option>
              <option value="false">No, I need to review</option>
            </Select>
          </div>
        </div>
        <h3>Select your presentation</h3>
        {/* <input type="file" onChange={handleFileChange} className="border p-2" /> */}
        <div
          {...getRootProps()}
          className="w-full max-w-md h-32 border-2 border-dashed border-gray-400 rounded flex items-center justify-center cursor-pointer text-center p-4"
        >
          <input {...getInputProps()} />
          {isDragActive ? (
            <div style={{width: '825px', height: '100px', backgroundColor: '#f2f2f2', borderRadius: '10px', padding: '20px'}}>Drop the file here...</div>
          ) : selectedFile ? (
            <p style={{fontSize: '15px', fontWeight:'bold'}}>{selectedFile.name}</p>
          ) : (
            <div style={{width: '825px', height: '100px', backgroundColor: '#f2f2f2', borderRadius: '10px', padding: '20px'}}>Drag & drop a file here, or click to select</div>
          )}
        </div>

        <Button $primary style={{width: '150px', padding: '10px', fontSize: '20px', borderRadius: '8px', marginTop: '20px'}} onClick={handleSubmit}>Create</Button>
      </> : null} 
      {convertState === "Converting" ? <>
        <h3>Converting</h3>
      </> : null}
      {convertState === "ConvertCompleted" ? <>
        <h3>Done</h3>
      </> : null}
    </div>
  );
}


export default PptToScenarioPage